import { Company } from "./company";
import { UntypedFormGroup } from "@angular/forms";
import { CompanyInfo } from "./company-info";
import { Address } from "./address";
import { CompanyKey } from "./company-key";

interface ICompanyHandler {
  handleFormToCompany(): Company;
  handleCompanyToForm(company: Company): void;
}

export class CompanyHandler implements ICompanyHandler {
  constructor(private formCompanyRegistration: UntypedFormGroup) {}

  handleFormToCompany(): Company {
    const company = new Company();
    const companyInfo = new CompanyInfo();
    const address = new Address();
    const companyKey = new CompanyKey();

    companyKey.setCompanyKey(this.formCompanyRegistration.value.companyKey);

    company.setCompanyKey(companyKey);
    company.setUnit(this.formCompanyRegistration.value.unit);
    company.setCompanyType(this.formCompanyRegistration.value.companyType);
    company.setHeadOfficeFiscalNumber(
      !!this.formCompanyRegistration.value.headOfficeFiscalNumber ? this.formCompanyRegistration.value.headOfficeFiscalNumber.replace(/[./-]/g, "") : null,
    );
    company.setFiscalNumber(!!this.formCompanyRegistration.value.fiscalNumber ? this.formCompanyRegistration.value.fiscalNumber.replace(/[./-]/g, "") : null);
    company.setStateRegistration(this.formCompanyRegistration.value.stateRegistration);
    company.setMunicipalRegistration(this.formCompanyRegistration.value.municipalRegistration);
    company.setCorporateName(this.formCompanyRegistration.value.corporateName);
    company.setTradingName(this.formCompanyRegistration.value.tradingName);
    company.setIsActive(this.formCompanyRegistration.value.isActive);

    address.setStreet(this.formCompanyRegistration.value.street);
    address.setNumber(this.formCompanyRegistration.value.number);
    address.setComplement(this.formCompanyRegistration.value.complement);
    address.setDistrict(this.formCompanyRegistration.value.district);
    address.setCity(this.formCompanyRegistration.value.city);
    address.setRegion(this.formCompanyRegistration.value.region);
    address.setZipCode(!!this.formCompanyRegistration.value.zipCode ? this.formCompanyRegistration.value.zipCode.replace(/[^\d]+/g, "") : null);
    companyInfo.setAddress(address);

    try{
      companyInfo.setEmployeeCount(parseInt(this.formCompanyRegistration.value.employeeCount));
    }catch{
      companyInfo.setEmployeeCount(0);
    }

    company.setCompanyInfo(companyInfo);

    return company;
  }

  handleCompanyToForm(company: Company): void {
    this.formCompanyRegistration.patchValue({
      companyKey: company.getCompanyKey().getCompanyKey(),
      unit: company.getUnit(),
      companyType: company.getCompanyType(),
      headOfficeFiscalNumber: company.getHeadOfficeFiscalNumber(),
      fiscalNumber: company.getFiscalNumber(),
      stateRegistration: company.getStateRegistration(),
      municipalRegistration: company.getMunicipalRegistration(),
      corporateName: company.getCorporateName(),
      tradingName: company.getTradingName(),
      street: company.getCompanyInfo().getAddress().getStreet(),
      number: company.getCompanyInfo().getAddress().getNumber(),
      complement: company.getCompanyInfo().getAddress().getComplement(),
      district: company.getCompanyInfo().getAddress().getDistrict(),
      city: company.getCompanyInfo().getAddress().getCity(),
      region: company.getCompanyInfo().getAddress().getRegion(),
      zipCode: company.getCompanyInfo().getAddress().getZipCode(),
      employeeCount: company.getCompanyInfo().getEmployeeCount(),
      isActive: company.getIsActive(),
    });
  }
}
